import { setTitle, tracker, newClickTracker,newViewTracker } from '@utils/index'

export function install(Vue: Vue.VueConstructor) {
  Vue.prototype.$tracker = tracker
  Vue.prototype.$newViewTracker = newViewTracker
  Vue.prototype.$newClickTracker = newClickTracker
  Vue.prototype.$setTitle = setTitle
  Vue.prototype.$bus = new Vue()
}
